import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/Bits";
import { CtaRow } from "@/components/CTAButtons";
import { CITIES, IMG } from "@/data/site";
import { MapPin } from "lucide-react";

export default function Areas() {
  return (
    <>
      <Seo
        title="Hotels Near Ottawa, Lawrence & Baldwin City, KS"
        description="Serving travelers across east-central Kansas — Ottawa, Lawrence, Baldwin City, Williamsburg, Richmond, Pomona, Princeton, Rantoul, Lane and Lyndon. A convenient I-35 hotel near universities, lakes and industrial employers."
        path="/areas"
        image={IMG.downtown}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Nearby Cities", path: "/areas" }]}
      />
      <PageHero
        kicker="Local Area"
        lines={["One stay,", "the whole", "region"]}
        sub="Right off I-35, we're the convenient basecamp for Ottawa and the surrounding communities — from KU game days in Lawrence to industrial projects along the corridor."
        image={IMG.downtown}
      />

      <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
        <SectionHeader kicker="Where We Serve" title="Nearby cities & communities" />
        <p className="mt-4 font-body text-sm text-fog">Drive times are approximate and may vary with traffic and route.</p>
        <div className="mt-14 grid gap-3 md:grid-cols-2">
          {CITIES.map((c, i) => (
            <Reveal key={c.name} i={i % 2} className="group flex items-start justify-between gap-6 border-2 border-charcoal bg-paper p-8 transition-colors duration-300 hover:bg-brand-yellow">
              <div>
                <h3 className="font-heading text-2xl font-black text-charcoal">{c.name}</h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-fog group-hover:text-charcoal/80">{c.desc}</p>
              </div>
              <div className="shrink-0 text-right">
                <MapPin className="ml-auto h-5 w-5 text-brand-red" />
                <p className="mt-2 font-body text-xs uppercase tracking-wide text-charcoal/70">{c.dist}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-16">
          <CtaRow />
        </div>
      </section>
    </>
  );
}
